__turbopack_context__.v({
  "wrapper": "priceRateButtons-module-scss-module__-fUxNG__wrapper",
});
